import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    id: "login",
    class: "auth"
};
var _hoisted_2 = { class: "row justify-content-center align-items-center" };
var _hoisted_3 = { class: "col-12 col-md-5" };
var _hoisted_4 = { class: "card text-bg-dark" };
var _hoisted_5 = { class: "card-body py-4" };
var _hoisted_6 = { class: "input-group mb-3" };
var _hoisted_7 = { class: "input-group mb-3" };
var _hoisted_8 = { class: "row flex-column align-items-center px-4 pt-2" };
var _hoisted_9 = { class: "d-flex justify-content-center align-items-center px-4 pt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "d-none d-md-block col-md-5" }, [
                _createElementVNode("img", {
                    class: "img-fluid",
                    src: "/imagenes/chica-login.webp"
                })
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-center" }, "Bienvenido de nuevo", -1)),
                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-center" }, "Accede a tu Subslot y administra tus espacios compartidos", -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_ctx.email) = $event); }),
                                placeholder: "Correo electrónico",
                                onKeyup: _cache[1] || (_cache[1] = _withKeys(
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.handleLogin && _ctx.handleLogin.apply(_ctx, args));
                                }, ["enter"]))
                            }, null, 544), [
                                [_vModelText, _ctx.email]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((_ctx.password) = $event); }),
                                placeholder: "Contraseña",
                                type: "password",
                                onKeyup: _cache[3] || (_cache[3] = _withKeys(
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.handleLogin && _ctx.handleLogin.apply(_ctx, args));
                                }, ["enter"]))
                            }, null, 544), [
                                [_vModelText, _ctx.password]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("button", {
                                class: "btn btn-secondary",
                                onClick: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    function () {
                                        var args = [];
                                        for (var _i = 0; _i < arguments.length; _i++) {
                                            args[_i] = arguments[_i];
                                        }
                                        return (_ctx.handleLogin && _ctx.handleLogin.apply(_ctx, args));
                                    })
                            }, "Ingresar"),
                            _createElementVNode("div", _hoisted_9, [
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-inline-block my-0" }, "¿Nuevo en Subslot?", -1)),
                                _cache[7] || (_cache[7] = _createTextVNode()),
                                _createVNode(_component_router_link, {
                                    to: "/registro",
                                    class: "register mx-2 my-0 d-inline-block"
                                }, {
                                    default: _withCtx(function () { return _cache[5] || (_cache[5] = [
                                        _createTextVNode("Regístrate")
                                    ]); }),
                                    _: 1
                                })
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
